export default __webpack_public_path__ + "static/media/accu-chek.e44652d0.jpg";